import glmat from 'gl-matrix'
import Emitter from 'event-emitter'
import RAF from './raf'

let vec2 = glmat.vec2

class Mouse {
  constructor (target) {
    this.cursor = vec2.fromValues(0, 0)
    this.lastCursor = vec2.fromValues(0, 0)
    this.velocity = vec2.fromValues(0, 0)

    this.target = target || window
    // this.wheel = vec2.fromValues(0, 0)
    // this.lastWheel = vec2.fromValues(0, 0)
    this.wheelVelocity = vec2.fromValues(0, 0)

    this.screenWidth = window.innerWidth
    this.screenHeight = window.innerHeight

    this.isDown = false

    this.emitter = {}
    Emitter(this.emitter)
    this.on = this.emitter.on.bind(this.emitter)

    RAF.suscribe('mouse', () => { this.update() })

    this.initEvents()
  }

  initEvents () {
    this.target.addEventListener('touchstart', (event) => { this.onDown(event.touches[0]) })
    this.target.addEventListener('touchend', (event) => { this.onUp(event.touches[0]) })
    this.target.addEventListener('touchmove', (event) => { this.onMouve(event.touches[0]) })

    this.target.addEventListener('mousedown', (event) => { this.onDown(event) })
    this.target.addEventListener('mousemove', (event) => { this.onMouve(event) })
    this.target.addEventListener('mouseup', (event) => { this.onUp(event) })

    this.target.addEventListener('wheel', (event) => { this.onWheel(event) })

    this.target.addEventListener('click', () => { this.emitter.emit('click') })
    this.target.addEventListener('resize', () => {
      this.screenWidth = window.innerWidth
      this.screenHeight = window.innerHeight
    })
  }

  onDown (event) {
    this.cursor[0] = (event.clientX / this.screenWidth - 0.5) * 2
    this.cursor[1] = (event.clientY / this.screenHeight - 0.5) * 2
    this.lastCursor[0] = this.cursor[0]
    this.lastCursor[1] = this.cursor[1]
    this.isDown = true
    this.emitter.emit('down', this)
  }

  onUp (event) {
    this.isDown = false
    this.emitter.emit('up', this)
  }

  onWheel (event) {
    this.wheelVelocity[0] = event.deltaX
    this.wheelVelocity[1] = event.deltaY
    this.emitter.emit('wheel', this)
  }

  onMouve (event) {
    this.cursor[0] = (event.clientX / this.screenWidth - 0.5) * 2
    this.cursor[1] = (event.clientY / this.screenHeight - 0.5) * 2
    this.emitter.emit('mouve', this)
    if (this.isDown) { this.emitter.emit('drag', this) }
  }

  update () {
    this.velocity[0] = this.cursor[0] - this.lastCursor[0]
    this.velocity[1] = this.cursor[1] - this.lastCursor[1]
    this.lastCursor[0] = this.cursor[0]
    this.lastCursor[1] = this.cursor[1]
  }
}

// const out = new Mouse()
export default Mouse
